<template>
    <div>
        <v-container fluid pt-3 grid-list-xl>
            <app-card customClasses="mb-30 inherit-overflow">
                <div>
                    <v-btn icon @click="back()">
                        <v-icon>arrow_left</v-icon>
                    </v-btn>
                </div>
                <div class="partner-contact-container">
                    <v-data-table v-bind:headers="headers" :items="selectedEvent.partners" hide-actions>
                        <template slot="items" slot-scope="props">
                            <td>{{ props.item.id }}</td>
                            <td>{{ props.item.name }}</td>
                            <td>11
                            </td>
                        </template>
                    </v-data-table>
                </div>
            </app-card>
        </v-container>
    </div>
</template>
    
<script>
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            headers: [
                {
                    text: 'ID',
                    value: "id",
                    align: 'left',
                },
                {
                    text: 'Name',
                    value: "name",
                    align: 'left',
                },
                {
                    text: 'Requested Tickets',
                    align: 'left',
                }
            ]
        }
    },
    computed: {
        ...mapGetters([
            'selectedEvent',
            'user'
        ]),
    },
    methods: {
        back() {
            this.$router.push({ name: 'waitinglist.events' })
        }
    },
    created() {
        if (this.$route.params.eventId) {
            this.eventId = this.$route.params.eventId;
            console.log(this.eventId)
            this.$store.dispatch('getGuestDetailsEvent', this.eventId);
        } else {
            this.$router.push({ name: 'waitinglist.events' });
        }
    }
}
</script>
    